import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {normalize, concatMergeStrategy, isApiResponseOk} from '../../util/utils';
import {HttpStatusCodes} from '../../util/uiconstants';

export function financialStatementReducer(state = initialstate.financialStatement, action) {
	switch (action.type) {
		case types.GET_TRIAL_BALANCE_BY_ID:
			if (isApiResponseOk(action)) {
				let financialStatements = [];

				for (const tb of action.response) {
					const trialBalanceId = action?.payload?.accountId ? `${tb.id}_${action.payload.accountId}` : tb.id;

					const updateTrialBalanceId = (financialStatements) => {
						for (const financial of financialStatements || []) {
							financial.trialBalanceId = trialBalanceId;
						}
					};

					updateTrialBalanceId(tb.firstLevelFinancialStatements);
					updateTrialBalanceId(tb.secondLevelFinancialStatements);
					updateTrialBalanceId(tb.thirdLevelFinancialStatements);
					updateTrialBalanceId(tb.fourthLevelFinancialStatements.data);

					financialStatements = financialStatements.concat(
						tb.firstLevelFinancialStatements,
						tb.secondLevelFinancialStatements,
						tb.thirdLevelFinancialStatements,
						tb.fourthLevelFinancialStatements.data
					);
				}

				financialStatements = financialStatements?.map((financial) => ({
					...financial,
					annotations: financial.annotations?.map((annotation) => annotation.id),
					isSelected: false
				}));

				// Delete from the state those financial statements for the trialBalanceId that do not exist in financialStatements
				const filteredState = {...state};
				let deletedCount = 0;
				const newFinancialStatementIds = new Set(financialStatements.map((f) => f.id));
				const newTrialBalanceIds = new Set(financialStatements.map((f) => f.trialBalanceId));

				for (const financial of Object.values(filteredState.byId)) {
					if (newTrialBalanceIds.has(financial.trialBalanceId) && !newFinancialStatementIds.has(financial.id)) {
						delete filteredState.byId[financial.id];
						deletedCount++;
					}
				}

				// Recalculate allIds only if something is deleted
				if (deletedCount > 0) {
					filteredState.allIds = Object.keys(filteredState.byId);
				}

				const normalized = normalize(financialStatements, undefined, filteredState, concatMergeStrategy);
				return {
					...normalized
				};
			}
			return state;
		case types.OPEN_ANNOTATION_MODAL: {
			const financialStatementId = action.financialStatementId;
			return {
				...state,
				byId: {
					...state.byId,
					[financialStatementId]: {
						...state.byId[financialStatementId],
						isSelected: true
					}
				}
			};
		}
		case types.CLEAR_ANNOTATION_MODAL: {
			const slice = state.byId;
			const financialStatements = Object.values(slice).map((financial) => {
				return {...financial, isSelected: false};
			});
			return {
				...normalize(financialStatements)
			};
		}
		case types.CREATE_ENTITY_ANNOTATION: {
			if (action.responseObj.status === HttpStatusCodes.Created) {
				// add newly added annotation into financialStatement list
				const financialStatementId = action.annotation.financialStatementId;
				return {
					...state,
					byId: {
						...state.byId,
						[financialStatementId]: {
							...state.byId[financialStatementId],
							annotations: [action.response.id]
						}
					}
				};
			}
			return state;
		}
		case types.DELETE_ENTITY_ANNOTATION: {
			if (action.responseObj.status === HttpStatusCodes.NoContent) {
				// delete deleted annotation from financialStatement list
				const financialStatementId = action.annotation.financialStatementId;
				return {
					...state,
					byId: {
						...state.byId,
						[financialStatementId]: {
							...state.byId[financialStatementId],
							annotations: []
						}
					}
				};
			}
			return state;
		}
		default:
			return state;
	}
}
